<div class="campanhas-page questionario-form-page">
  <header class="campanha-form-header">
    <div class="campanha-form-title-block">
      <app-back-button routerLink="/questionarios" data-testid="link-voltar" />
      <h1 class="page-main-title" data-testid="questionario-form-title">{{ pageTitle() }}</h1>
    </div>
    @if (!edicaoBloqueada()) {
      <div class="campanha-form-header-actions">
        <button
          type="button"
          class="btn btn-outline-primary"
          data-testid="btn-selecionar-pergunta-cadastrada"
          (click)="onAbrirSelecionarPergunta()"
        >
          Selecionar pergunta cadastrada
        </button>
        <button
          type="button"
          class="btn btn-primary"
          data-testid="btn-adicionar-pergunta"
          (click)="onAbrirCriarPergunta()"
        >
          Adicionar pergunta
        </button>
      </div>
    }
  </header>

  @if (edicaoBloqueada()) {
    <div class="questionario-bloqueio" role="status">
      <span class="questionario-bloqueio-icone" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
             stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="5" y="11" width="14" height="10" rx="2" />
          <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
      </span>
      <div class="questionario-bloqueio-texto">
        <strong class="questionario-bloqueio-titulo">Somente visualização</strong>
        <p class="questionario-bloqueio-motivo" data-testid="questionario-bloqueio-edicao">
          {{ motivoBloqueioEdicao() }}
        </p>
      </div>
    </div>
  }

  <form [formGroup]="form" class="campanha-form" data-testid="questionario-form">

    <!-- 1. Informações gerais -->
    <section class="campanha-form-section">
      <h2 class="campanha-form-section-title">1. Informações gerais</h2>
      <div class="campanha-form-fields">
        <div class="row g-3">
          <div class="col-12 col-md-4">
            <label class="campanha-form-label" for="questionario-tipo">
              Tipo de Questionário <span class="campanha-form-required">*</span>
            </label>
            <select
              id="questionario-tipo"
              class="form-select campanha-form-control"
              [class.is-invalid]="showControlError('tipo')"
              formControlName="tipo"
              data-testid="select-questionario-tipo"
            >
              @for (tipo of tiposQuestionario; track tipo) {
                <option [value]="tipo">{{ tipo }}</option>
              }
            </select>
            @if (showControlError('tipo')) {
              <div class="invalid-feedback" data-testid="tipo-error">Campo obrigatório.</div>
            }
          </div>
          <div class="col-12 col-md-8">
            <label class="campanha-form-label" for="questionario-nome">
              Nome <span class="campanha-form-required">*</span>
            </label>
            <input
              id="questionario-nome"
              type="text"
              class="form-control campanha-form-control"
              [class.is-invalid]="showControlError('nome')"
              formControlName="nome"
              placeholder="Digite o nome do questionário"
              data-testid="input-nome"
            />
            @if (showControlError('nome')) {
              <div class="invalid-feedback" data-testid="nome-error">Campo obrigatório.</div>
            }
          </div>
        </div>
      </div>
    </section>

    <!-- 2. Perguntas -->
    <section class="campanha-form-section">
      <h2 class="campanha-form-section-title">2. Perguntas</h2>
      <div class="campanha-form-fields">

        @for (perguntaGroup of perguntaGroups; track $index; let i = $index) {
          <div
            class="questionario-pergunta-row"
            [class.questionario-pergunta-row--invalid]="perguntaIncompleta(i)"
            [attr.draggable]="!edicaoBloqueada()"
            (dragstart)="onPerguntaDragStart(i)"
            (dragover)="onPerguntaDragOver($event)"
            (drop)="onPerguntaDrop(i)"
            data-testid="pergunta-item"
          >
            <span class="questionario-drag-handle" aria-hidden="true" data-testid="pergunta-drag-handle">⠿</span>
            <span class="questionario-pergunta-index" data-testid="pergunta-index">Pergunta {{ i + 1 }}</span>
            <span class="questionario-pergunta-preview" data-testid="pergunta-preview">
              {{ perguntaGroup.get('texto')!.value || 'Sem enunciado' }}
            </span>
            @if (perguntaIncompleta(i)) {
              <span class="questionario-pergunta-erro" data-testid="pergunta-alternativas-erro">
                ⚠ Pergunta incompleta
              </span>
            }
            <div class="questionario-pergunta-actions">
              <button
                type="button"
                class="campanha-form-icon-btn"
                [attr.aria-label]="'Visualizar pergunta ' + (i + 1)"
                data-testid="btn-visualizar-pergunta"
                (click)="onVisualizarPergunta(i)"
              >
                👁
              </button>
              <button
                type="button"
                class="campanha-form-icon-btn"
                [attr.aria-label]="'Editar pergunta ' + (i + 1)"
                [disabled]="edicaoBloqueada()"
                data-testid="btn-editar-pergunta"
                (click)="onEditarPergunta(i)"
              >
                ✎
              </button>
              <button
                type="button"
                class="campanha-form-icon-btn campanha-form-icon-btn--remove"
                [attr.aria-label]="'Excluir pergunta ' + (i + 1)"
                [disabled]="excluindo() || edicaoBloqueada()"
                data-testid="btn-excluir-pergunta"
                (click)="onExcluirPergunta(i)"
              >
                🗑
              </button>
            </div>
          </div>
        } @empty {
          <p class="questionario-empty-state" data-testid="perguntas-empty">
            Nenhuma pergunta adicionada. Clique em "Adicionar pergunta" para começar.
          </p>
        }
      </div>
    </section>

    <!-- 3. Associe o perfil -->
    <section class="campanha-form-section">
      <h2 class="campanha-form-section-title">3. Associe o perfil</h2>
      <div class="campanha-form-fields">
        <div class="questionario-perfis">
          <div class="questionario-perfil-selecao row g-3 align-items-end">
            <div class="col-12 col-md-8">
              <label class="campanha-form-label" for="questionario-perfil-associado">
                Lista perfil cadastrado
              </label>
              <app-perfil-autocomplete
                inputId="questionario-perfil-associado"
                [perfis]="perfisDisponiveisParaSelecao"
                [formControl]="perfilSelecionadoId"
              />
            </div>
            <div class="col-12 col-md-4">
              <button
                type="button"
                class="btn btn-primary"
                [disabled]="!perfilSelecionadoId.value"
                (click)="onAdicionarPerfilAssociado()"
                data-testid="btn-adicionar-perfil"
              >
                +
              </button>
            </div>
          </div>

          <div class="questionario-perfil-card">
            @if (carregandoPerfis()) {
              <p class="questionario-empty-state" data-testid="perfis-loading">
                Carregando perfis de investimento...
              </p>
            } @else if (perfis.length === 0) {
              <p class="questionario-empty-state" data-testid="perfis-empty">
                Nenhum perfil associado. Selecione um perfil e clique em "+" para adicionar.
              </p>
            } @else {
              <div class="questionario-grid-row questionario-grid-row--perfil questionario-grid-row--head">
                <span class="questionario-col-label">Perfil</span>
                <span class="questionario-col-label">Pontuação mínima</span>
                <span class="questionario-col-label">Pontuação máxima</span>
                <span class="questionario-col-label"></span>
              </div>

              @for (perfilGroup of perfilGroups; track $index; let k = $index) {
                <div
                  class="questionario-grid-row questionario-grid-row--perfil questionario-row-item"
                  [formGroup]="perfilGroup"
                  data-testid="perfil-item"
                >
                  <div class="questionario-perfil-nome" data-testid="perfil-nome">
                    @if (perfilCadastrado(perfilGroup); as perfil) {
                      <span>{{ perfil.nome }}</span>
                      <span class="questionario-perfil-portal" data-testid="perfil-nome-portal">
                        Nome exibido para o participante:
                        <strong>{{ perfil.nomeExibicao || perfil.nome }}</strong>
                      </span>
                    } @else {
                      <span>{{ perfilGroup.value.nomePerfil }}</span>
                    }
                  </div>
                  <div>
                    <input
                      type="number"
                      class="form-control campanha-form-control"
                      formControlName="pontuacaoMinima"
                      min="0"
                      [class.is-invalid]="
                        showPerfilControlError(perfilGroup, 'pontuacaoMinima') ||
                        pontuacaoComProblema(perfilGroup, 'minima')
                      "
                      [attr.aria-label]="'Pontuação mínima do perfil ' + perfilGroup.value.nomePerfil"
                      data-testid="input-perfil-min"
                    />
                    @if (showPerfilControlError(perfilGroup, 'pontuacaoMinima')) {
                      <span class="campanha-form-error" data-testid="input-perfil-min-error">
                        Informe a pontuação mínima.
                      </span>
                    }
                  </div>
                  <div>
                    <input
                      type="number"
                      class="form-control campanha-form-control"
                      formControlName="pontuacaoMaxima"
                      min="0"
                      [class.is-invalid]="
                        showPerfilControlError(perfilGroup, 'pontuacaoMaxima') ||
                        pontuacaoComProblema(perfilGroup, 'maxima')
                      "
                      [attr.aria-label]="'Pontuação máxima do perfil ' + perfilGroup.value.nomePerfil"
                      data-testid="input-perfil-max"
                    />
                    @if (showPerfilControlError(perfilGroup, 'pontuacaoMaxima')) {
                      <span class="campanha-form-error" data-testid="input-perfil-max-error">
                        Informe a pontuação máxima.
                      </span>
                    }
                  </div>
                  <button
                    type="button"
                    class="campanha-form-icon-btn campanha-form-icon-btn--remove"
                    [attr.aria-label]="'Remover perfil ' + perfilGroup.value.nomePerfil"
                    [attr.data-testid]="'btn-remover-perfil-' + k"
                    [disabled]="excluindo() || edicaoBloqueada()"
                    (click)="onExcluirPerfilAssociado(k)"
                  >
                    🗑
                  </button>
                </div>
              }
            }
          </div>

          <!-- Abaixo da lista: a pessoa acabou de ver as faixas. O que precisa ser corrigido vem
               primeiro; a linha do intervalo atingível fecha a seção como referência. -->
          @if (problemasCoberturaPerfis().length > 0) {
            <ul class="questionario-perfil-cobertura-erros" role="alert">
              @for (problema of problemasCoberturaPerfis(); track problema.mensagem) {
                <li class="campanha-form-error" data-testid="perfil-cobertura-error">
                  {{ problema.mensagem }}
                </li>
              }
            </ul>
          }

          @if (pontuacaoAtingivel(); as atingivel) {
            <p class="questionario-perfil-cobertura" data-testid="perfil-pontuacao-atingivel">
              As respostas somam de <strong>{{ atingivel.minima }}</strong> a
              <strong>{{ atingivel.maxima }}</strong> pontos. As faixas dos perfis precisam cobrir
              esse intervalo inteiro, sem sobra nem sobreposição.
            </p>
          }
        </div>
      </div>
    </section>

    <!-- 3. Valide as informações do seu questionário -->
    <section class="campanha-form-section">
      <h2 class="campanha-form-section-title">4. Valide as informações do seu questionário</h2>
      <div class="questionario-form-validar-row">
        <p class="questionario-form-validar-hint">Clique aqui e Visualize seu questionário</p>
        <div class="questionario-form-validar-actions">
          <button
            type="button"
            class="btn btn-outline-primary"
            data-testid="btn-visualizar-questionario"
            (click)="onAbrirVisualizarQuestionario()"
          >
            Visualizar Questionário
          </button>
          <button
            type="button"
            class="btn btn-outline-primary"
            data-testid="btn-exportar-questionario"
            (click)="onExportarQuestionario()"
          >
            Exportar
          </button>
        </div>
      </div>
    </section>

  </form>

  <footer
    class="campanha-form-footer"
    role="toolbar"
    aria-label="Ações do formulário"
    data-testid="questionario-form-footer"
  >
    @if (!edicaoBloqueada()) {
      @if (motivoSalvarDesabilitado(); as motivo) {
        <p class="questionario-form-salvar-motivo" data-testid="btn-salvar-motivo">
          {{ motivo }}
        </p>
      }

      <div class="campanha-form-footer-actions">
        @if (podeSalvarComoRascunho()) {
          <button
            type="button"
            class="btn btn-outline-primary campanha-form-footer-btn"
            [disabled]="isSaving() || motivoSalvarDesabilitado() !== null"
            (click)="onSalvarRascunho()"
            data-testid="btn-salvar-rascunho"
          >
            Salvar como rascunho
          </button>
        }
        <button
          type="button"
          class="btn btn-primary campanha-form-footer-btn"
          [disabled]="isSaving() || motivoSalvarDesabilitado() !== null"
          (click)="onSalvar()"
          data-testid="btn-salvar"
        >
          {{ isEditMode() ? 'Salvar' : 'Criar' }}
        </button>
      </div>
    }
    <button
      type="button"
      class="questionario-form-cancelar-link"
      (click)="onCancelar()"
      data-testid="btn-cancelar"
    >
      Cancelar
    </button>
  </footer>

  @if (showCriarPerguntaModal()) {
    <app-criar-pergunta-modal
      [form]="criarPerguntaForm"
      [submitAttempted]="criarPerguntaSubmitAttempted()"
      (cancelar)="onCancelarCriarPergunta()"
      (criar)="onConfirmarCriarPergunta()"
    />
  }

  @if (perguntaSelecionada(); as sel) {
    <app-pergunta-modal
      [perguntaGroup]="perguntaGroups[sel.index]"
      [modo]="sel.modo"
      [indice]="sel.index"
      (adicionarAlternativa)="onAdicionarAlternativa(perguntaGroups[sel.index])"
      (removerAlternativa)="onExcluirAlternativa(perguntaGroups[sel.index], $event)"
      (fechar)="perguntaSelecionada.set(null)"
    />
  }

  @if (showSelecionarPerguntaModal()) {
    <app-selecionar-pergunta-modal
      [perguntas]="perguntasCadastradas()"
      [carregando]="carregandoPerguntasCadastradas()"
      (selecionar)="onSelecionarPerguntaCadastrada($event)"
      (fechar)="onCancelarSelecionarPergunta()"
    />
  }

  @if (showVisualizarModal()) {
    <app-visualizar-questionario-modal
      [questionario]="visualizarQuestionarioValue()"
      (fechar)="onFecharVisualizarQuestionario()"
    />
  }

  @if (perguntaParaExcluir() != null) {
    <app-alert-dialog
      title="Excluir pergunta"
      message="Tem certeza que deseja excluir esta pergunta?"
      description="Essa ação removerá a pergunta e suas alternativas. Não poderá ser desfeita."
      cancelLabel="Cancelar"
      confirmLabel="Excluir"
      (cancel)="onCancelarExclusaoPergunta()"
      (confirm)="onConfirmarExclusaoPergunta()"
    />
  }

  @if (alternativaParaExcluir() != null) {
    <app-alert-dialog
      title="Excluir alternativa"
      message="Tem certeza que deseja excluir esta alternativa?"
      description="Essa ação removerá a alternativa da pergunta. Não poderá ser desfeita."
      cancelLabel="Cancelar"
      confirmLabel="Excluir"
      (cancel)="onCancelarExclusaoAlternativa()"
      (confirm)="onConfirmarExclusaoAlternativa()"
    />
  }

  @if (perfilParaExcluir() != null) {
    <app-alert-dialog
      title="Excluir perfil associado"
      [message]="'Tem certeza que deseja excluir o perfil ' + perfilParaExcluirNome() + '?'"
      description="Essa ação removerá o perfil e sua pontuação do questionário. Não poderá ser desfeita."
      cancelLabel="Cancelar"
      confirmLabel="Excluir"
      (cancel)="onCancelarExclusaoPerfil()"
      (confirm)="onConfirmarExclusaoPerfil()"
    />
  }
</div>
